import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { serviceApi } from '~/features';
import { SponsoredProductsReportsCampaignDto } from '~/types';

export const DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_CAMPAIGN_MUTATION_KEY =
  'DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_CAMPAIGN_MUTATION';

async function exportSponsoredProductsCampaignReport(
  params: SponsoredProductsReportsCampaignDto
) {
  return serviceApi.get<Blob>(`/ReportProdutoPatrocinado/Produtos-Export`, {
    params,
    responseType: 'blob',
  });
}

export function useDownloadSponsoredProductsReportsCampaign(
  onSuccess?: (
    data: AxiosResponse<Blob, unknown>,
    variables: SponsoredProductsReportsCampaignDto,
    context: SponsoredProductsReportsCampaignDto
  ) => unknown,
  onError?: (
    error: Error,
    variables: SponsoredProductsReportsCampaignDto,
    context: SponsoredProductsReportsCampaignDto | undefined
  ) => unknown
) {
  return useMutation({
    mutationKey: [DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_CAMPAIGN_MUTATION_KEY],
    mutationFn: async (params: SponsoredProductsReportsCampaignDto) =>
      exportSponsoredProductsCampaignReport(params),
    onSuccess,
    onError,
  });
}
